export const colors = {
    primary: "#FD9E2E",
    white:"#C5BFB6FF"
};